var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    attrs: {
      "id": "chemical-search-wrapper",
      "data-test": "chemical-search-wrapper"
    }
  }, [_c('b-form-group', {
    staticClass: "chemical-search-by-label",
    attrs: {
      "label": _vm.searchByLabel,
      "label-for": "chemical-search-type"
    }
  }, [!_vm.useLocalChemical ? _c('raft-autocomplete', {
    key: _vm.fieldConfig.field_name,
    ref: "autocomplete",
    attrs: {
      "field-class": "entity-reference-field",
      "id": _vm.fieldConfig.field_name,
      "name": _vm.fieldConfig.field_name,
      "default-value": _vm.selectedItem,
      "label": _vm.fieldConfig.label,
      "element-id": "chemical-search-autocomplete",
      "placeholder": _vm.getPlaceholder(),
      "source": _vm.debounceChemicalLookup,
      "results-display": _vm.formattedResultsDisplay,
      "results-formatter": _vm.formatResults,
      "results-property": _vm.resultsProperty,
      "input-class": "form-control",
      "disabled": _vm.disabled,
      "field-required": _vm.required,
      "show-label": false,
      "is-chemsnap-enabled": _vm.isChemsnapEnabled,
      "chemsnap-found": _vm.defaultLookupValue,
      "border-status": _vm._status
    },
    on: {
      "selected": _vm.updateSelected,
      "clear": function ($event) {
        return _vm.clearSelected();
      },
      "search": _vm.updateSearch
    },
    scopedSlots: _vm._u([{
      key: "helptext",
      fn: function () {
        return [_vm.searchResultsCount === 0 && _vm.hasSearched ? [_vm._v("\n          No matches found.\n          "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('search-unlinked-chemicals', _vm.searchTerm);
            }
          }
        }, [_vm._v("Search unlinked chemicals")]), _vm._v("?\n        ")] : _vm._e(), _vm._v(" "), _vm.searchResultsCount > 0 && _vm.hasSearched ? [_vm._v("\n          " + _vm._s(_vm.selectedOrChooseHelpText) + "\n          "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              _vm.$refs.autocomplete.open = true;
            }
          }
        }, [_vm._v(_vm._s(_vm.searchResultsLinkText))]), _vm._v(".\n          "), _c('a', {
          attrs: {
            "href": "#"
          },
          on: {
            "click": function ($event) {
              $event.preventDefault();
              return _vm.$emit('search-unlinked-chemicals', _vm.searchTerm);
            }
          }
        }, [_vm._v("Search unlinked chemicals")]), _vm._v("?\n        ")] : _vm._e()];
      },
      proxy: true
    }, _vm.horizontalOptions ? {
      key: "radiogroup",
      fn: function () {
        return [_c('div', {
          staticClass: "horizontal-search-by-chemical"
        }, [_c('div', {
          staticClass: "chemical-title"
        }, [_c('span', [_vm._v("Chemical")])]), _vm._v(" "), _c('div', {
          staticClass: "chemical-options"
        }, [_c('div', {
          staticClass: "field-label field__label required",
          attrs: {
            "title": "This field is required."
          }
        }, [_c('span', [_vm._v("By")])]), _vm._v(" "), _vm.optionsAbove && !_vm.useLocalChemical ? _c('b-form-radio-group', {
          attrs: {
            "id": "chemical-search-type",
            "options": _vm.searchOptions,
            "name": "radio-options"
          },
          model: {
            value: _vm.chemicalSearchType,
            callback: function ($$v) {
              _vm.chemicalSearchType = $$v;
            },
            expression: "chemicalSearchType"
          }
        }) : _vm._e()], 1)])];
      },
      proxy: true
    } : {
      key: "radiogroup",
      fn: function () {
        return [_c('div', {
          staticClass: "field-label field__label required",
          attrs: {
            "title": "This field is required."
          }
        }, [_vm._v("\n          " + _vm._s(_vm.getSearchLabel()) + ":\n          "), _c('sup', [_vm._v("*")])]), _vm._v(" "), _vm.optionsAbove && !_vm.useLocalChemical ? _c('b-form-radio-group', {
          class: {
            'chemical-search-options-inline-above': _vm.optionsInline,
            'chemical-search-options-stacked': !_vm.optionsInline
          },
          attrs: {
            "id": "chemical-search-type",
            "options": _vm.searchOptions,
            "name": "radio-options",
            "button": true
          },
          model: {
            value: _vm.chemicalSearchType,
            callback: function ($$v) {
              _vm.chemicalSearchType = $$v;
            },
            expression: "chemicalSearchType"
          }
        }) : _vm._e()];
      },
      proxy: true
    }, _vm.chemsnapFound && !_vm.showSearchInput ? {
      key: "input",
      fn: function () {
        return [_c('ChemSnapMatchBadge', {
          attrs: {
            "result-value": _vm.chemsnapFound
          },
          on: {
            "change-chemsnap-match": _vm.handleChemsnapMatchChange
          }
        })];
      },
      proxy: true
    } : null], null, true)
  }) : _c('div', {
    attrs: {
      "id": "unlinked-chemical-selection"
    }
  }, [_c('div', {
    staticClass: "column unlinked-pair"
  }, [_c('strong', [_vm._v("Chemical Name")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.localChemicalTitle))])]), _vm._v(" "), _vm.allowDelete ? _c('FilterClearButton', {
    staticClass: "autocomplete__icon autocomplete--clear",
    on: {
      "click": function ($event) {
        return _vm.clearSelected();
      }
    }
  }) : _vm._e()], 1), _vm._v(" "), !_vm.optionsAbove ? _c('b-form-radio-group', {
    staticClass: "chemical-search-options-inline",
    attrs: {
      "id": "chemical-search-type",
      "options": _vm.searchOptions,
      "name": "radio-options"
    },
    model: {
      value: _vm.chemicalSearchType,
      callback: function ($$v) {
        _vm.chemicalSearchType = $$v;
      },
      expression: "chemicalSearchType"
    }
  }) : _vm._e(), _vm._v(" "), _vm._t("extra")], 2), _vm._v(" "), _c('div', {
    staticClass: "chemical-search-unnamed-slot"
  }, [_vm._t("default")], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }